import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { formatDateTime } from '../../shared/utils/date';

const RunStopsList = ({ stops }) => {
    return (
        <BootstrapTable data={stops}>
            <TableHeaderColumn dataField="stopId" isKey hidden>
                ID
            </TableHeaderColumn>
            <TableHeaderColumn dataField="stopNumber" width="50">
                #
            </TableHeaderColumn>
            <TableHeaderColumn dataField="stopName">Stop Name</TableHeaderColumn>
            <TableHeaderColumn dataField="stopCode" width="150">
                Stop Code
            </TableHeaderColumn>
            <TableHeaderColumn dataField="stopPlantCode" width="150">
                Plant Code
            </TableHeaderColumn>
            <TableHeaderColumn dataField="stopDockCode" width="150">
                Dock Code
            </TableHeaderColumn>
            <TableHeaderColumn dataField="plannedArrival" dataFormat={formatDateTime} width="150">
                Arrival
            </TableHeaderColumn>
            <TableHeaderColumn dataField="plannedDeparture" dataFormat={formatDateTime} width="150">
                Departure
            </TableHeaderColumn>
        </BootstrapTable>
    );
};

export default RunStopsList;
